"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = void 0;
const react_1 = __importDefault(require("react"));
const select_1 = __importDefault(require("antd/lib/select"));
class Dropdown extends react_1.default.PureComponent {
  render() {
    const _a = this.props,
      _a$options = _a.options,
      options = _a$options === void 0 ? [] : _a$options,
      style = _a.style,
      inputProps = __rest(_a, ["options", "style"]);
    return react_1.default.createElement(select_1.default, Object.assign({}, inputProps, {
      style: style
    }), options.map((_a, index) => {
      var title = _a.title,
        option = __rest(_a, ["title"]);
      return react_1.default.createElement(select_1.default.Option, Object.assign({}, option, {
        key: index.toString()
      }), title);
    }));
  }
}
exports.Dropdown = Dropdown;
exports.default = Dropdown;